import { useEffect, useRef, useState } from "react";

/**
 * Soft #ceaa7d backlight that lights up on hover (desktop) and on touch (mobile).
 * Wraps card content: pass card classes via className; visual card element via `as`.
 */
export default function GlowCard({
  as: Tag = "div",
  className = "",
  children,
  litDuration = 1100,
  ...rest
}) {
  const [lit, setLit] = useState(false);
  const timer = useRef(null);

  const lightUp = () => {
    setLit(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setLit(false), litDuration);
  };

  useEffect(() => () => clearTimeout(timer.current), []);

  const handlers = {
    onTouchStart: lightUp,
    onMouseEnter: () => setLit(true),
    onMouseLeave: () => setLit(false),
  };

  return (
    <Tag
      {...rest}
      {...handlers}
      className={`card-glow ${lit ? "card-glow--lit" : ""} ${className}`}
    >
      {children}
    </Tag>
  );
}
